/**
 * @file index.tsx
 *
 * @fileoverview Renders organization social link.
 */
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { FlexItem } from '~/vcl/atoms/06-layout/03-flex/02-flex-item';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Text } from '~/vcl/atoms/13-text/03-text';
import styles from './socialLinks.module.scss';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface OrganizationInfoBoxWidgetSocialLinkProps {
  /**
   * The label component.
   */
  Label: string;
  /**
   * The icon component.
   */
  Icon: React.FC<any>;
  /**
   * The social link.
   */
  href: string;
}

export default function OrganizationInfoBoxWidgetSocialLink({
  Label,
  Icon,
  href,
}: OrganizationInfoBoxWidgetSocialLinkProps) {
  const { APP } = useFrontendConfig();
  const SOCIAL_ICONS_COLORED = APP.SOCIAL_ICONS_COLORED;

  return (
    <>
      <FlexItems className={styles.socialMediaLink}>
        <FlexItem marginRight={5}>
          <Icon
            title={Label}
            width="16"
            {...(!SOCIAL_ICONS_COLORED ? { color: 'primary' } : null)}
          />
        </FlexItem>
        <FlexItem marginRight={5}>
          <Text margin={0} color="gray4">
            <a
              href={href}
              target="_blank"
              referrerPolicy="no-referrer"
              rel="nofollow noreferrer"
            >
              {Label}
            </a>
          </Text>
        </FlexItem>
      </FlexItems>
      <Spacing />
    </>
  );
}

export { OrganizationInfoBoxWidgetSocialLink };
